/**
 * @fileoverview Centered public layout for authentication and recovery screens.
 * @provides PublicShell with branded visual treatment and route outlet.
 * @usedBy Login, OTP verification, and error routes.
 * @uses React Router Outlet and semantic design tokens.
 * @accessibility Provides a single main landmark and responsive reading width.
 */
import { useEffect } from "react";
import { Outlet } from "react-router";
import { setDocumentMeta } from "../lib/document-meta";
export function PublicShell() { useEffect(() => setDocumentMeta({ title: "Sign in · Art of Living Campaigns", description: "Secure campaign portal access.", canonical: "https://leads.softwareseva.org/login", index: false }), []); return <main className="grid min-h-screen place-items-center bg-[radial-gradient(circle_at_top,var(--secondary),var(--background)_55%)] px-4 py-10"><div className="w-full max-w-md"><Outlet /></div></main>; }
